import {emailIsValid} from "./emailIsValid";
import {COMMON_NAMESPACE} from "../../utils/i18nNameSpaces";

export const emailInputValidate = (state, t) => {
  if (emailIsValid(state.value)) {
    state.isValid = true;
    return;
  }

  state.error = t(`${COMMON_NAMESPACE}:error.email`);
}